import { notionists } from "@dicebear/collection";
import { createAvatar } from "@dicebear/core";
import { AvatarConfig } from "common";
import React, { useEffect, useState } from "react";

interface AvatarProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  config: AvatarConfig;
  round?: boolean;
}

export const Avatar = ({ config, round, ...imgProps }: AvatarProps) => {
  const [svg, setSvg] = useState<string | null>(null);
  useEffect(() => {
    const loadAvatar = async () => {
      const dataUrl = await createAvatar(notionists, {
        beard: config.beard ? [config.beard as any] : undefined,
        beardProbability: config.beard ? 100 : 0,
        body: [config.body as any],
        bodyIcon: config.bodyIcon ? [config.bodyIcon as any] : undefined,
        bodyIconProbability: config.bodyIcon ? 100 : 0,
        brows: [config.brows as any],
        eyes: [config.eyes as any],
        gesture: config.gesture ? [config.gesture as any] : undefined,
        gestureProbability: config.gesture ? 100 : 0,
        glasses: config.glasses ? [config.glasses as any] : undefined,
        glassesProbability: config.glasses ? 100 : 0,
        hair: [config.hair as any],
        lips: [config.lips as any],
        nose: [config.nose as any],
        backgroundColor: config.backgroundColor
          ? [config.backgroundColor as any]
          : undefined,
      }).toDataUri();
      setSvg(dataUrl);
    };
    loadAvatar();
  }, [config]);

  if (!svg) {
    return null;
  }

  return (
    <img
      src={svg}
      alt={"user avatar"}
      {...imgProps}
      style={{
        ...imgProps.style,
        ...(round
          ? {
              borderRadius: "50%",
              overflow: "hidden",
            }
          : {}),
      }}
    />
  );
};
